import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { GraphemeReferenceView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.reference";

/**
 * The bare morpheme route's Reference screen.
 *
 * Keeping Reference in its real `index.tsx` route lets Expo Router select `index`, `info`, or
 * `mnemonics` from the matched URL during both server rendering and hydration. Branching in the
 * parent layout from `usePathname`/`useSegments` was not stable during production SSR: the server
 * saw the parent route and rendered Reference for `/info`, while the browser selected Info and
 * discarded the mismatched tree during hydration.
 */
export function MorphemeReferencePanel() {
  const [grapheme] = useContextSelectors(MorphemePanelsContext, (context) => context.character);
  return <GraphemeReferenceView grapheme={grapheme} />;
}
